import createApi from "../utils/apiClient";
const api = createApi();

export const getLeaves =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch({ type: "LEAVES_REQUEST" });
      const { data } = await api.get("/leaves", { params });
      dispatch({ type: "LEAVES_SUCCESS", payload: data.leaves });
    } catch (err) {
      dispatch({ type: "LEAVES_FAIL", payload: err.response?.data?.message });
    }
  };

export const applyLeave = (formData) => async (dispatch) => {
  try {
    dispatch({ type: "LEAVE_REQUEST" });
    const { data } = await api.post("/leaves", formData);
    dispatch({ type: "LEAVE_SUCCESS", payload: data.leave });
    return data;
  } catch (err) {
    dispatch({ type: "LEAVE_FAIL", payload: err.response?.data?.message });
    throw err;
  }
};

export const updateLeaveStatus = (id, status) => async (dispatch) => {
  try {
    const { data } = await api.put(`/leaves/${id}`, { status });
    dispatch(getLeaves());
    return data;
  } catch (err) {
    throw err;
  }
};

export const cancelLeave = (id) => async (dispatch) => {
  try {
    await api.delete(`/leaves/${id}`);
    dispatch(getLeaves());
  } catch (err) {
    throw err;
  }
};
